import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';
import { GoogleAuthSecretType, GoogleAuthSetup } from './GoogleAuthSetup';

interface MfaGoogleAuthProps {
    onMfaUpdate?: (value: boolean) => void;
}
export function MfaGoogleAuth({ onMfaUpdate }: MfaGoogleAuthProps) {
    const services = React.useContext(ServicesContext);
    const user = services.user.get();
    const [googleAuthVerified, setGoogleAuthVerified] = React.useState(
        user?.two_factor_auth?.is_google_authenticator_enabled
    );
    const [confirmDisable, setConfirmDisable] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [googleAuthSecret, setGoogleAuthSecret] = React.useState<GoogleAuthSecretType>();

    async function getSecret() {
        setLoading(true);
        const response = await services.api.call({
            method: 'post',
            url: '/api/totp-authenticators',
            data: {
                provider: 'google',
            },
        });
        setGoogleAuthSecret(response.data);
        setLoading(false);
    }

    async function disableGoogleAuth() {
        setLoading(true);
        await services.user.deleteGoogleAuth();
        setGoogleAuthVerified(false);
        setConfirmDisable(false);
        setLoading(false);
        if (onMfaUpdate) {
            onMfaUpdate(false);
        }
    }

    function displayButtons() {
        if (confirmDisable) {
            return (
                <>
                    <button
                        className="btn btn-danger"
                        onClick={disableGoogleAuth}
                        type="button"
                        disabled={loading}
                    >
                        {loading && (
                            <Spinner animation="border" size="sm" role="status" className="me-2" />
                        )}
                        Disable
                    </button>
                    <button
                        className="btn btn-secondary ms-2"
                        onClick={() => setConfirmDisable(false)}
                        type="button"
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </>
            );
        }
        if (googleAuthVerified) {
            return (
                <button
                    className="btn btn-primary"
                    onClick={() => setConfirmDisable(true)}
                    type="button"
                >
                    Update
                </button>
            );
        }
        return (
            <button
                className="btn btn-primary"
                onClick={getSecret}
                type="button"
                disabled={loading}
            >
                {loading && <Spinner animation="border" size="sm" role="status" className="me-2" />}
                Use App
            </button>
        );
    }

    return (
        <div className="row align-items-center">
            {googleAuthSecret ? (
                <GoogleAuthSetup
                    googleAuthSecret={googleAuthSecret}
                    setGoogleAuthVerified={setGoogleAuthVerified}
                    setGoogleAuthSecret={setGoogleAuthSecret}
                    onMfaUpdate={() => onMfaUpdate && onMfaUpdate(true)}
                />
            ) : (
                <>
                    <div className="col-3 text-end">Google Authenticator</div>
                    <div className="col-3">
                        {googleAuthVerified ? (
                            <i
                                className="fa-solid fa-check-circle text-success"
                                title="This Google Authenticator can now be used for 2-step verification when logging in"
                            />
                        ) : (
                            'None'
                        )}
                    </div>
                    <div className="col-6 text-end text-nowrap">{displayButtons()}</div>
                    {confirmDisable && (
                        <div className="col-12 text-center mt-3">
                            Are you sure you want to disable 2-step verification via Google
                            Authenticator?
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
